import styled, { css } from 'styled-components';


export const StepBarOuterContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`;

export const StepBarContainer = styled.div<{isActive:boolean}>`
	height: 25px;
	flex-basis: 100%;
	margin: 3px;
`;

export const StepBar = styled.div<{isActive:boolean}>`
	width: 100%;
	height: 2px;
	background-color: ${(props) => props.theme.colors.lightGray};
	margin-top: 5px;

	${(props) => props.isActive && css`
		background-color: ${(props) => props.theme.colors.backgroundBlack};
	`}
`;

export const StepIndicatorText = styled.div`
	width: 100%;
	text-align: center;
	color: ${(props) => props.theme.colors.backgroundBlack};
`;

export const StepIndicatorContainer = styled.div<{mobile:boolean, menuScaleFactor:number}>`
	width: 100%;
	box-sizing: border-box;

	${(props) => props.mobile && css`
		& ${StepBarContainer} {
			height: ${10 * props.menuScaleFactor}px;
		};

		& ${StepBar} {
			margin-top: ${5 * props.menuScaleFactor}px;
		};

		& ${StepIndicatorText} {
			margin-top: ${2 * props.menuScaleFactor}px;
			font-size: ${13 * props.menuScaleFactor}px;
		};
	`}
`;